<template>
    <div class="modal fade" id="generic_complaint" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="genericComplaintLabel">New Complaint</h4>
                </div>
                <form method="post" @submit.prevent="registerNewGenericComplaint()">
                    <div class="modal-body">
                        <div class="form-group">
                            <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                                <div class="sk-bounce1"></div>
                                <div class="sk-bounce2"></div>
                                <div class="sk-bounce3"></div>
                            </div>
                            <label >Complainant Phone</label>
                            <input v-on:blur="checkForCustomer()" required="required" v-bind:readonly="complaint.id !== 0"  v-model="complaint.complainantNumber" type="text" class="form-control" placeholder="Complainant Phone...">
                        </div>
                        <div class="form-group">
                            <label >Complainant Name</label>
                            <input required="required" v-bind:readonly="complaint.id !== 0" v-model="complaint.complainantName" type="text" class="form-control" placeholder="Complainant Name...">
                        </div>
                        <div class="form-group">
                            <label>Select Nature</label>
                            <select v-bind:disabled="complaint.id !== 0" v-model="complaint.complaintsNature.id" class="form-control" required="required">
                                <option v-for="(nature, index) in natures" v-bind:value="nature.id" v-bind:key="'nature_'+index">{{nature.nature}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label >Complaint</label>
                            <textarea required="required" v-bind:readonly="complaint.id !== 0" v-model="complaint.complaint" rows="5" class="form-control min-width" placeholder="Complaint..."></textarea>
                        </div>
                        <div class="form-group">
                            <label>Vendor Name</label>
                            <select v-bind:disabled="complaint.id !== 0" required="required" v-model="complaint.restaurantName" class="form-control">
                                <option v-for="restaurant in restaurants" v-bind:key="'res_complain_' + restaurant.id" v-bind:value="restaurant.name">{{restaurant.name}}</option>
                            </select>
                        </div>
                        <!--<div class="form-group">-->
                            <!--<label >Vendor Name</label>-->
                            <!--<input required="required" v-bind:readonly="complaint.id !== 0" v-model="complaint.restaurantName" type="text" class="form-control" placeholder="Vendor Name...">-->
                        <!--</div>-->
                        <section v-if="complaint.userName !== null && complaint.id !== 0">
                            <div class="form-group">
                                <label >Registered By</label>
                                <input required="required" v-bind:readonly="complaint.id !== 0" type="text" class="form-control" v-bind:value="complaint.userName">
                            </div>
                            <div class="form-group">
                                <label >Registered On</label>
                                <input required="required" v-bind:readonly="complaint.id !== 0" type="text" class="form-control" v-bind:value="complaint.created">
                            </div>
                        </section>

                        <section v-if="complaint.actionRequestedBy !== null && complaint.id !== 0">
                            <div class="form-group">
                                <label >Action Requested By</label>
                                <input required="required" v-bind:readonly="complaint.id !== 0" type="text" class="form-control" v-bind:value="complaint.actionRequestedBy">
                            </div>
                            <div class="form-group">
                                <label >Action Requested On</label>
                                <input required="required" v-bind:readonly="complaint.id !== 0" type="text" class="form-control" v-bind:value="complaint.actionRequestedOn">
                            </div>
                            <div class="form-group">
                                <label >Requested Action</label>
                                <input required="required" v-bind:readonly="complaint.id !== 0" type="text" class="form-control" v-bind:value="(complaint.requestOfAction === 1) ? 'Resolved': 'Ignored'">
                            </div>
                            <div class="form-group">
                                <label >Requested Solution / Notes</label>
                                <input required="required" v-bind:readonly="complaint.id !== 0" type="text" class="form-control" v-bind:value="complaint.complaintSolution">
                            </div>
                        </section>
                        <section v-if="complaint.decidedBy !== null && complaint.id !== 0">
                            <div class="form-group">
                                <label >Decided By</label>
                                <input required="required" v-bind:readonly="complaint.id !== 0" type="text" class="form-control" v-bind:value="complaint.decidedBy">
                            </div>
                            <div class="form-group">
                                <label >Decided On</label>
                                <input required="required" v-bind:readonly="complaint.id !== 0" type="text" class="form-control" v-bind:value="complaint.decidedOn">
                            </div>
                        </section>
                        <div class="form-group" v-if="complaint.id !== 0 && (userRole === 'ROLE_ADMIN' || userRole === 'ROLE_USER' || userRole === 'ROLE_MANAGER')">
                            <label>Resolution Notes</label>
                            <textarea rows="5" required="required" class="form-control" v-bind:readonly="complaint.status !== 'NEW'" v-model="complaint.complaintSolution"></textarea>
                        </div>
                        <div class="form-group" v-if="complaint.decidedBy !== null && complaint.id !== 0">
                            <label >Final Decision</label>
                            <input required="required" v-bind:readonly="complaint.id !== 0" type="text" class="form-control" v-bind:value="complaint.status">
                        </div>

                        <div v-if="complaint.id !== 0 && (userRole === 'ROLE_ADMIN' || userRole === 'ROLE_USER' || userRole === 'ROLE_MANAGER') && complaint.decidedBy === null" class="form-group">
                            <label >Update Status</label>
                            <select required="required" class="form-control" v-model="complaint.status">
                                <option value="NEW">NEW</option>
                                <option value="IGNORED">Ignored</option>
                                <option v-if="userRole !== 'ROLE_MANAGER'" value="RESOLVED">Resolved</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    export default {
        name: "GenericComplaint",
        data() {
            return {
                userRole: "",
                isHideSpinner: "hide",
                natures: [],
                restaurants: [],
                complaint:{
                    id: 0,
                    complaint: "",
                    status: "NEW",
                    orders: null,
                    complainantName: "",
                    complainantNumber: "",
                    restaurantName: "",
                    complaintsNature: {
                        id: 0
                    }
                }
            }
        },
        mounted: function () {
            $('#generic_complaint').on('hidden.bs.modal',  (e) => {
                if(this.$parent.dtTable !== undefined && this.$parent.dtTable !== null){
                    this.$parent.dtTable.draw();
                }
                this.resetData();
            });
        },
        methods: {
            load: function (complaintId) {
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                    this.restaurants = resp.data;
                });
                this.$http.get(this.$store.state.mainAppURL +  "complaints/get_all_natures").then(resp => {
                    this.natures = resp.data;
                });
                let loggedInUser = this.$store.state.user;
                if(loggedInUser){
                    this.userRole = loggedInUser.userRolesById[0].role;
                }
                if(complaintId > 0){
                    let params = new URLSearchParams();
                    params.append("complaint_id", complaintId);
                    this.$http.post(this.$store.state.mainAppURL+"complaints/get_complaint_by_id",params).then(resp => {
                        this.complaint = resp.data;
                        if(resp.data.orderId !== null){
                            this.complaint.orders = {
                                id: resp.data.orderId
                            };
                        }
                        console.log(this.complaint);
                    });
                }
                $("#generic_complaint").modal("show");
            },
            registerNewGenericComplaint: function () {
                if(this.complaint.id === 0){
                    this.complaint.userName = this.$store.state.user["fullName"];
                }else if(this.complaint.id !== 0 && this.complaint.decidedBy === null){
                    this.complaint.decidedBy = this.$store.state.user["fullName"];
                    this.complaint.decidedOn = new Date();
                }
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                this.$http.post(this.$store.state.mainAppURL + "complaints/register_generic_complaint", this.complaint).then(resp => {
                    if(resp.data){
                        this.resetData();
                        $("#generic_complaint").modal("hide");
                        Swal.close();
                    }else{
                        swal("Error!" ," Please Try Again", "error");
                    }
                });
            },
            checkForCustomer: function(){
                let params = new URLSearchParams();
                params.append("contact_number", this.complaint.complainantNumber);
                this.$http.post(this.$store.state.mainAppURL + "customers/find_customer_from_contact", params).then(resp => {
                    if(resp.data){
                        this.complaint.complainantName = resp.data.name;
                    }
                });
            },
            resetData: function () {
                Object.assign(this.$data, this.$options.data.call(this));
            }
        }
    }
</script>

<style scoped>
    .sk-spinner-three-bounce div{
        width: 10px !important;
        height: 10px !important;
    }
    .min-width {
      min-width: 535px;
    }
</style>
